module.exports = __webpack_public_path__ + "static/img/HARVEY-LANGFORD.f4948d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HARVEY-LANGFORD.jpg
// module id = Q550
// module chunks = 0